module.exports = __webpack_public_path__ + "img/bg_avatar_male_82.0fe012ad.png";